// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DropdownButton-module__dropdownButtonContainer___2ZnzH{width:auto;height:auto;cursor:pointer}.DropdownButton-module__dropdownContentContainer___10JFl{position:absolute;width:auto;height:auto;border-radius:10px;background-color:var(--primaryBGColor);padding:10px 15px;filter:drop-shadow(0 2px 6px rgba(0, 0, 0, 0.3));-webkit-filter:drop-shadow(0 2px 6px rgba(0, 0, 0, 0.3));z-index:1000;transition:all ease-in-out 300ms;min-width:150px;min-height:20px}", ""]);
// Exports
exports.locals = {
	"dropdownButtonContainer": "DropdownButton-module__dropdownButtonContainer___2ZnzH",
	"dropdownContentContainer": "DropdownButton-module__dropdownContentContainer___10JFl"
};
module.exports = exports;
